import {ValueByDevice} from 'platform/foundation';

import {CSSProperties} from 'react';

/**
 * The matrix scrolls horizontally on a narrow screen, where a sticky label column would eat
 * 104px of the viewport and still drift out of alignment at the end of the scroll.
 */
export const COMPARISON_STICKY_POSITION: ValueByDevice<CSSProperties['position']> = [
  'static',
  'static',
  'sticky',
];
